'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;
//import { loadData } from 'redux/modules/templateData';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

var _reduxAsyncConnect = require('redux-async-connect');

var _semanticUiReact = require('semantic-ui-react');

var _components = require('components');

var _auth = require('redux/modules/auth');

var _infoBlock = require('redux/modules/infoBlock');

var info = _interopRequireWildcard(_infoBlock);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Content = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    templates: state.company.content_templates,
    design_template_id: state.templateData.design_template_id,
    loaded_content: state.templateData.loaded_content,
    infoBlock: state.templateData.info_block,
    userData: state.saveUserData.load_data,
    show_content_label: state.company.show_content_label,
    ReactGA: state.company.ReactGA,
    base_url: state.company.base_url,
    content_template_id: state.templateData.content_template_id,
    user_data_id: state.templateData.user_data_id,
    resume_name: state.templateData.resume_name
  };
}, (0, _extends3.default)({ pushState: _reactRouterRedux.push,
  loadDesignTemplateData: _templateData.loadDesignTemplateData,
  loadContentTemplateData: _templateData.loadContentTemplateData,
  chooseContentTemplate: _templateData.chooseContentTemplate,
  updateLoadedEditor: _auth.updateLoadedEditor,
  cleanTemplateData: _templateData.clean,
  cleanInfo: info.clean,
  setResumeName: _templateData.setResumeName
}, templateActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Content, _Component);

  function Content(props) {
    (0, _classCallCheck3.default)(this, Content);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Content.__proto__ || (0, _getPrototypeOf2.default)(Content)).call(this, props));

    _this.state = {
      selected_content_id: false,
      selected_design_id: false,
      resume_name: false
    };
    return _this;
  }

  (0, _createClass3.default)(Content, [{
    key: 'componentWillMount',
    value: function componentWillMount() {

      if (this.props.content_template_id) {
        this.setState({
          selected_content_id: this.props.content_template_id,
          selected_design_id: this.props.design_template_id,
          resume_name: this.props.resume_name
        });
      }
      // console.log(this.props)
      // if(this.props.infoBlock) {
      //   this.props.pushState(this.props.base_url + '/design-view');
      // }
      // if(this.props.content_template_id || this.props.user_data_id){
      //   this.props.pushState(this.props.base_url + '/design-view');
      // }
      // if(this.props.design_template_id){
      //   // this.props.loadDesignTemplateData(this.props.design_template_id);
      // } else {
      //   this.props.pushState(this.props.base_url + '/choose-design');
      // }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // if(nextProps.loaded_content){
      //   this.props.pushState(this.props.base_url + '/design-view');
      // }
      //

      if (!this.props.content_template_id && nextProps.content_template_id) {
        this.props.pushState(this.props.base_url + '/design-view');
        // this.props.loadContentTemplateData(nextProps.content_template_id);
      }

      if (this.props.content_template_id != nextProps.content_template_id) {
        this.props.pushState(this.props.base_url + '/design-view');
      }
    }
  }, {
    key: 'selectTemplate',
    value: function selectTemplate(template_id) {
      var design_template_id = this.props.design_template_id;
      var userData = this.props.userData;

      if (this.props.content_template_id == template_id) {
        this.props.pushState(this.props.base_url + '/design-view');
      }

      if (this.props.content_template_id) {
        if (this.props.content_template_id != template_id) {
          var confirm = window.confirm('Selecting this template will overwrite your current resume.\n Are you sure you want to proceed?');
          if (confirm) {
            this.props.cleanInfo();
            this.props.cleanTemplateData();
            this.props.setResumeName(this.state.resume_name);
            this.props.chooseTemplate(this.state.selected_design_id);
            this.props.chooseContentTemplate(template_id);
          }
        }
      } else {
        this.props.chooseContentTemplate(template_id);
        this.props.updateLoadedEditor();
      }
      //
      // var check = true;
      // for(var i=0; i < userData.length; i++) {
      //   if(userData[i].design_template === design_template_id
      //     && userData[i].content_template === template_id) {
      //     check = false;
      //     break;
      //   }
      // }
      // if(check) {
      //   this.props.loadContentTemplateData(template_id);
      // }
      // else {
      //   var confirm = window.confirm('You already have a resume saved with this design and profile combination.\nIf you proceed, your previously saved data for this combination will be overwritten. Are you sure you want to proceed?');
      //   if(confirm) {
      //     this.props.loadContentTemplateData(template_id);
      //   }
      // }

      //this.props.pushState('/design-view');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // const {info, load} = this.props; // eslint-disable-line no-shadow
      var styles = require('./Content.scss');

      var templates = this.props.templates;
      var templates_copy = JSON.parse((0, _stringify2.default)(this.props.templates));

      var current;
      var sort_keys = [];
      var category_keys = [];
      var result = [];

      for (var k in templates_copy) {
        sort_keys.push(templates_copy[k]['sort_key']);
        category_keys.push(k);
      }

      var all = [];

      for (var i = 0; i < category_keys.length; i++) {
        all.push({ 'sort_keys': sort_keys[i], 'category_keys': category_keys[i] });
      }

      all.sort(function (a, b) {
        return a.sort_keys - b.sort_keys;
      });

      sort_keys = [];
      category_keys = [];

      for (var i = 0; i < all.length; i++) {
        sort_keys.push(all[i].sort_keys);
        category_keys.push(all[i].category_keys);
      }

      if (this.props.design_template_id) {
        var segmentwrapper = category_keys.map(function (templateCategory) {
          current = templateCategory;
          return _react2.default.createElement(
            _semanticUiReact.Segment,
            { style: { background: 'rgba(245,245,245,.5)', marginTop: 10, marginBottom: 20 } },
            _react2.default.createElement(
              _semanticUiReact.Label,
              { as: 'a', color: 'black', ribbon: true },
              templateCategory
            ),
            _react2.default.createElement(
              _semanticUiReact.Card.Group,
              { style: { marginTop: 8 }, itemsPerRow: 5 },
              templates[current]['data'].map(function (template) {
                return _react2.default.createElement(
                  _semanticUiReact.Card,
                  {
                    key: template.id,
                    raised: true,
                    onClick: function onClick() {
                      _this2.selectTemplate(template.id);
                      _this2.props.ReactGA.set({ dimension2: current + ' - ' + template.name });
                      _this2.props.ReactGA.event({
                        category: 'Resume - Choose Profile',
                        action: current + ' - ' + template.name,
                        label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
                      });
                    },
                    color: 'black',
                    style: { minWidth: 180, textAlign: 'center' }
                  },
                  _react2.default.createElement(_semanticUiReact.Card.Content, { header: template.name }),
                  _react2.default.createElement(
                    _semanticUiReact.Card.Description,
                    { style: { textAlign: 'center', padding: 8 } },
                    _this2.props.show_content_label && template.free && _react2.default.createElement(
                      _semanticUiReact.Label,
                      {
                        style: { background: 'white',
                          color: 'teal',
                          padding: 4,
                          border: 'teal 1px solid'
                        } },
                      'FREE'
                    ),
                    _this2.props.show_content_label && !template.free && _react2.default.createElement(
                      _semanticUiReact.Label,
                      {
                        style: { background: 'white',
                          color: 'red',
                          padding: 4,
                          border: 'red 1px solid'
                        } },
                      'Premium'
                    )
                  )
                );
              })
            )
          );
        });

        return _react2.default.createElement(
          'div',
          { style: { paddingLeft: 50, paddingTop: 50, paddingRight: 50 } },
          _react2.default.createElement(_components.UserProgress, { designScreen: false, homeScreen: false }),
          _react2.default.createElement(
            'h3',
            { style: { float: 'left' } },
            'Choose your profile'
          ),
          _react2.default.createElement(_components.Search, { selectTemplate: this.selectTemplate.bind(this), style: { float: 'right' }, data: this.props.templates }),
          segmentwrapper
        );
      } else {
        return _react2.default.createElement(
          _semanticUiReact.Segment,
          { style: { minHeight: 400 } },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { active: true, inverted: true },
            _react2.default.createElement(_semanticUiReact.Loader, { inverted: true, content: 'Loading' })
          )
        );
      }
    }
  }]);
  return Content;
}(_react.Component), _class2.propTypes = {
  info: _react.PropTypes.object
  // load: PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = Content;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Content/Content.js
// module id = 1757
// module chunks = 0